<template>
  <el-dialog
    title="选择目标节点"
    :visible.sync="relatedInformationDialog"
    :close-on-click-modal="false"
    width="800px"
    @opened="afterOpen"
  >
    <div class="record-content">
      <el-table
        :data="selectDesObj.afterNodes"
        style="width: 100%;max-height:400px;overflow-y: auto;"
        border
        header-cell-class-name="todo-header-row"
        row-class-name="todo-row"
        size="medium"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
      >
        <el-table-column
          v-if="selectDesObj.jumpType"
          label="选择节点"
          align="left"
        >
          <template slot-scope="scope">
            <el-radio v-model="selectNodeId" :label="scope.row.nodeId">{{
              scope.row.nodeName
            }}</el-radio>
          </template>
        </el-table-column>

        <el-table-column
          v-if="!selectDesObj.jumpType"
          label="目标节点"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.nodeName }} </span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="selectDesObj.choiceExcutor"
          width="500"
          label="选择处理人"
          align="left"
        >
          <template slot-scope="scope">
            <el-select
              style="width:300px"
              v-model="scope.row.selectUserIds"
              v-if="
                selectDesObj.choiceExcutor == 'candidate' &&
                  scope.row.nodeType != 'end'
              "
              clearable
              filterable
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="item in scope.row.excutorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <ht-user-selector
              v-model="scope.row.selectUsers"
              v-if="
                selectDesObj.choiceExcutor != 'candidate' &&
                  scope.row.nodeType != 'end'
              "
              permission="w"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="showOpinion">
      <table cellspacing="0" cellpadding="0" border="0" class="form-table">
        <tbody>
          <tr>
            <th style="width: 100px;">
              <span class="xh-star">*</span>审批意见：
            </th>
            <td colspan="3">
              <OpinionText
                :text="text"
                ref="opinionText"
                @getOpinion="getOpinion"
              />
            </td>
          </tr>
          <tr v-if="action == 'agree' && signatureField && !secretFree">
            <th style="width: 100px;">
              <span class="xh-star">*</span>签章密码：
            </th>
            <td colspan="3">
              <el-input v-model="signaturePassword" show-password></el-input>
            </td>
          </tr>
          <tr>
            <th style="width: 100px;">附件上传：</th>
            <td colspan="3">
              <FileUpload ref="fileUpload" :flowKey="flowThis.defKey" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        v-if="
          (selectDesObj.help != '' || selectDesObj.helpGlobal != '') &&
            (selectDesObj.jumpType == 'free' ||
              selectDesObj.jumpType == 'select' ||
              selectDesObj.jumpType == 'free,select' ||
              selectDesObj.jumpType == 'select,free')
        "
        class="help"
        icon="el-icon-question"
        type="text"
        @click="help"
        >帮助</el-button
      >
      <el-button
        type="primary"
        @click="confirm"
        size="small"
        :disabled="disabled"
        >确 定</el-button
      >
      <el-button @click="closeDailog" size="small">取 消</el-button>
    </div>
    <el-dialog
      title="帮助"
      :visible.sync="helpDialog"
      width="55%"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="max-height:600px;overflow: auto;" v-html="valHelp"></div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import HtUserSelector from "@/components/control/HtUserSelector.vue";
import OpinionText from "@/components/common/opinionText.vue";
import FileUpload from "@/components/common/fileUpload.vue";
import utils from "@/utils.js";
import flow from "@/api/flow.js";
import { debuglog } from "util";

export default {
  name: "taskSelectDestination",
  props: [
    "defId",
    "taskId",
    "leaderId",
    "opinion",
    "action",
    "instId",
    "signatureField", //自动签章字段
    "signatureCover", //自动签章是否覆盖
    "secretFree" //自动签章时是否免密
  ],
  components: {
    HtUserSelector,
    OpinionText,
    FileUpload
  },
  data() {
    return {
      text: "",
      boData: {},
      opinionField: "",
      appendOpinion: false,
      data: {},
      appendStr: true,
      wrap: "\n",
      initBoAttr: "",
      signaturePassword: "",
      isSignatureCallBack: false,
      signatureLoading: null,
      flowThis: "", //flowAction的this,
      showOpinion: true,
      relatedInformationDialog: false,
      helpDialog: false,
      disabled: false,
      selectNodeId: "",
      files: "",
      zfiles: "",
      formData: "",
      selectDesObj: {},
      token: utils.getUrlKey("token"),
      valHelp: "",
      proInstId: "" //处理人时传过来的流程实例ID
    };
  },
  computed: mapState({
    curOrgPost: state => state.user.postCharge
  }),
  methods: {
    //帮助
    help() {
      this.helpDialog = true;
    },
    //鼠标点击页面其他其他位置不关闭弹框
    showDialog(
      formData,
      files,
      zfiles,
      instId,
      jumpType,
      type,
      opinionField,
      boData,
      appendOpinion,
      completeData,
      _this
    ) {
      if (this.$route.query.type === "free") {
        jumpType = "free";
      }
      if (type) {
        this.flowThis = _this;
        this.data = completeData;
        this.opinionField = opinionField;
        this.boData = boData;
        this.appendOpinion = appendOpinion;
      } else {
        this.showOpinion = false;
      }
      formData = formData || "";
      this.proInstId = instId;
      this.files = files;
      this.zfiles = zfiles;
      this.formData = formData;
      this.selectNodeId = "";
      this.selectDesObj = {};
      this.jumpType = jumpType;
      this.relatedInformationDialog = true;
      this.$store
        .dispatch("storeProcess/getAfterJumpNodes", {
          taskId: this.taskId || "",
          data: formData.data || formData,
          defId: this.defId || "",
          instId: this.instId || "",
          type: this.jumpType || ""
        })
        .then(data => {
          let Base64 = require("js-base64").Base64;
          this.selectDesObj = data;
          //此操作为改节点为设置自由跳转，通过manage端的任务跳转按钮跳过来时可提供自由跳转功能
          if (this.$route.query.type === "free") {
            this.selectDesObj.jumpType = this.jumpType;
            this.selectDesObj.choiceExcutor = this.jumpType;
          }
          if (this.selectDesObj.afterNodes.length == 1) {
            this.selectNodeId = this.selectDesObj.afterNodes[0].nodeId;
          }
          if (this.selectDesObj.helpGlobal == "null") {
            this.selectDesObj.helpGlobal = "";
          }
          if (this.selectDesObj.help == "null") {
            this.selectDesObj.help = "";
          }
          if (
            this.selectDesObj.helpGlobal != "" &&
            this.selectDesObj.help != ""
          ) {
            this.valHelp = Base64.decode(this.selectDesObj.help, "utf-8");
          } else if (
            this.selectDesObj.helpGlobal == "" &&
            this.selectDesObj.help != ""
          ) {
            this.valHelp = Base64.decode(this.selectDesObj.help, "utf-8");
          } else if (this.selectDesObj.helpGlobal != "") {
            this.valHelp = Base64.decode(this.selectDesObj.helpGlobal, "utf-8");
          }
        });
    },
    afterOpen() {
      if (this.showOpinion) {
        if (this.opinionField) {
          let con = document.querySelector(
            "[model-name='data." + this.opinionField + "']"
          );
          if (con && con.__vue__ && con.__vue__.isEditor) {
            this.wrap = "<br>";
          }
        }
        // let param = { instId: this.instId, taskId: this.taskId };
        // flow.getBpmSaveOpinionByTeam(param).then(resp => {
        //   if (resp.state && resp.value) {
        //     this.getOpinion(resp.value);
        //   } else {
        //     if (this.action == "agree" || this.action == "agreeTrans") {
        //       this.getOpinion("同意");
        //     } else if (
        //       this.action == "oppose" ||
        //       this.action == "opposeTrans"
        //     ) {
        //       this.getOpinion("反对");
        //     }
        //   }
        // });
      }
    },
    //获取意见
    getOpinion(opinion) {
      this.text = opinion;
      let opinioValue = this.$refs.opinionText.getOpinion();
      if (this.opinionField) {
        let currentUser = this.$store.state.user.currentUserDetail.user;
        let moment = require("moment");

        let boData = this.boData;
        let filed = this.opinionField.split(".");
        if (boData[filed[0]][filed[1]] == "<p><br/></p>") {
          boData[filed[0]][filed[1]] = "";
        }
        //是否覆盖审批意见
        if (this.appendOpinion) {
          if (opinioValue) {
            boData[filed[0]][filed[1]] =
              opinioValue +
              this.wrap +
              currentUser.fullname +
              " " +
              moment().format("YYYY-MM-DD HH:mm:ss");
          }
        } else {
          if (opinioValue) {
            opinioValue +=
              this.wrap +
              currentUser.fullname +
              " " +
              moment().format("YYYY-MM-DD HH:mm:ss");
          }
          if (this.appendStr) {
            this.initBoAttr = boData[filed[0]][filed[1]];
          }
          if (filed.length == 2) {
            if (this.initBoAttr) {
              if (opinion) {
                boData[filed[0]][filed[1]] =
                  this.initBoAttr + this.wrap + this.wrap + opinioValue;
              } else {
                boData[filed[0]][filed[1]] = this.initBoAttr;
              }
            } else {
              boData[filed[0]][filed[1]] = opinioValue;
            }
          }
          this.appendStr = false;
        }
      }
    },
    closeDailog() {
      this.relatedInformationDialog = false;
      this.getOpinion("");
    },
    confirm() {
      if (this.action == "agree" && this.signatureField) {
        let _this = this;
        this.isSignatureCallBack = false;
        this.$store.dispatch("storeProcess/initSignature", {}).then(rep => {}); //点同意按钮先初始化状态
        this.$store
          .dispatch("storeProcess/doSignature", {
            status: "start",
            field: this.signatureField,
            isCover: this.signatureCover,
            secretFree: this.secretFree,
            password: this.signaturePassword
          })
          .then(rep => {
            _this.signatureLoading = this.$loading({
              lock: true,
              text: "正在进行签章处理...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            // 设置5秒超时机制，如果超时则弹出提示
            setTimeout(function() {
              _this.signatureLoading.close();
              if (_this.isSignatureCallBack == false) {
                _this.$message({
                  type: "warning",
                  message: "签章处理超时，请联系管理员确定是否配置签章控件。"
                });
                return;
              }
            }, 5000);
          });
      } else {
        this.submitConfirm();
      }
    },
    submitConfirm() {
      let data = {
        data: this.formData.data || this.formData,
        taskId: this.taskId || "",
        defId: this.defId || "",
        proInstId: this.instId || "",
        actionName: "agree",
        files: this.files,
        zfiles: this.zfiles,
        formType: "inner",
        opinion: this.opinion,
        agentLeaderId: this.leaderId,
        isSendNodeUsers: "1"
      };
      //审批控件
      if (this.showOpinion) {
        data.data = Base64.encode(JSON.stringify(this.boData));
        if (this.$refs.fileUpload.getFiles() != "") {
          data.files = JSON.stringify(this.$refs.fileUpload.getFiles());
        }
        if (this.$refs.opinionText.getOpinion()) {
          data.opinion = this.$refs.opinionText.getOpinion();
        } else {
          this.$message({ type: "warning", message: "请输入审批意见" });
          return;
        }
      }
      if (this.formData.businessKey) {
        data.formType = "frame";
        data.businessKey = this.formData.businessKey;
        data.sysCode = this.formData.sysCode;
        if (this.formData.vars) {
          data.vars = this.formData.vars;
        }
      }
      //如果用户选择看目标节点，则将节点的跳转类也传到后台

      data.destination = this.selectNodeId;
      if (
        !data.destination &&
        this.selectDesObj.afterNodes &&
        this.selectDesObj.afterNodes.length == 1
      ) {
        data.destination = this.selectDesObj.afterNodes[0].nodeId;
      }
      if (this.selectDesObj.jumpType) {
        data.jumpType =
          this.selectDesObj.jumpType == "select" ? "select" : "free";
      }

      let nodeUsers = [];
      //遍历所有的节点将其所选择的节点。
      if (this.selectDesObj && this.selectDesObj.choiceExcutor == "candidate") {
        for (
          let index = 0;
          index < this.selectDesObj.afterNodes.length;
          index++
        ) {
          const node = this.selectDesObj.afterNodes[index];
          if (node.selectUserIds && node.selectUserIds.length > 0) {
            const excutorList = node.excutorList;
            const selectusers = [];
            for (let index = 0; index < excutorList.length; index++) {
              const user = excutorList[index];
              if (user && node.selectUserIds.indexOf(user.id) > -1) {
                selectusers.push(user);
              }
            }
            nodeUsers.push({ nodeId: node.nodeId, executors: selectusers });
          }
        }
      } else if (this.selectDesObj) {
        for (
          let index = 0;
          index < this.selectDesObj.afterNodes.length;
          index++
        ) {
          const node = this.selectDesObj.afterNodes[index];
          if (node.selectUsers && node.selectUsers.length > 0) {
            const excutorList = node.selectUsers;
            const selectusers = [];
            for (let index = 0; index < excutorList.length; index++) {
              const user = excutorList[index];
              selectusers.push({
                id: user.id,
                name: user.fullname,
                type: "user"
              });
            }
            nodeUsers.push({ nodeId: node.nodeId, executors: selectusers });
          }
        }
      }

      if (nodeUsers.length > 0) {
        data.nodeUsers = JSON.stringify(nodeUsers);
      }
      if (window.urgentStateValue) {
        data.urgentStateValue = window.urgentStateValue;
      }
      if (this.taskId) {
        this.$confirm("确认办理此任务?", "提示", {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning",
          closeOnClickModal: false
        }).then(() => {
          this.disabled = true;
          this.$store
            .dispatch("storeProcess/complete", data)
            .then(() => {
              //如果是模块开发进来的，则跳转到待办列表
              if (this.$route.name.indexOf("reportModuleInst") != -1) {
                //数据视图
                this.$router.push(
                  "/statement/template/preview/" +
                    this.$route.params.templateKey +
                    "/todo/" +
                    this.$route.params.defKey +
                    "/true"
                );
              } else if (this.$route.name.indexOf("sysModuleInst") != -1) {
                //从模块开发的待办中心进来
                this.$router.push(
                  "/v-flow/v-todo/" + this.$route.params.defKey
                );
              } else {
                this.$router.push("/inst/" + this.proInstId + "/doneList");
              }
              // if(this.token!=null){
              //   window.close();
              // }else{
              //   this.$router.go(-1);
              // }
            })
            .catch(() => {
              this.disabled = false;
            });
        });
      } else {
        if (this.curOrgPost && this.curOrgPost.org) {
          data.startOrgId = this.curOrgPost.org.id;
        }
        this.disabled = true;
        data.supportMobile = 1;
        this.$store
          .dispatch("storeProcess/start", data)
          .then(() => {
            if (this.token != null) {
              window.close();
            } else {
              this.$router.go(-1);
            }
          })
          .catch(() => {
            this.disabled = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.record-container {
  border-bottom: 1px solid #ebeef5;
  padding: 20px 0 10px;
}

.record-container > span {
  border-left: 3px solid $--theme-color;
  font-weight: bold;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}

.record-content {
  padding: 10px 0;
}

.form-table {
  width: 100%;
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.form-table th {
  text-align: right;
  color: #666;
}

.form-table th > span {
  color: #f00;
}

.form-table th,
.form-table td {
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  padding: 10px;
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.recordInformation {
  text-align: right;
  width: 15%;
}

.overstriking {
  font-weight: 700;
}

.help {
  float: left;
}

/deep/.el-dialog__body {
  overflow: auto;
  padding: 10px 20px;
  color: $--color-text-regular;
  font-size: 14px;
}
</style>
